import type {
  Baseline,
  BaselineDeviation,
} from '@alphahub/eie-core';

export function computeDeviation(baseline: Baseline | undefined, valence: number, arousal: number): BaselineDeviation | undefined {
  if (!baseline) return undefined;

  const v = valence - baseline.avgValence;
  const a = arousal - baseline.avgArousal;

  const clampPercent = (shift: number, avg: number): number => {
    if (Math.abs(avg) < 0.05) return 0;
    const pct = (shift / Math.abs(avg)) * 100;
    return Math.max(-200, Math.min(200, pct));
  };

  const minStd = 0.05;
  const effectiveStdV = Math.max(baseline.stdValence ?? 0, minStd);
  const effectiveStdA = Math.max(baseline.stdArousal ?? 0, minStd);

  return {
    valence: v,
    arousal: a,
    valencePercent: clampPercent(v, baseline.avgValence),
    arousalPercent: clampPercent(a, baseline.avgArousal),
    zScoreValence: v / effectiveStdV,
    zScoreArousal: a / effectiveStdA,
  };
}

export function getMostFrequent<T>(arr: T[]): T {
  if (arr.length === 0) return 'neutral' as T;
  const counts = new Map<T, number>();
  arr.forEach(item => counts.set(item, (counts.get(item) || 0) + 1));
  return Array.from(counts.entries()).reduce((a, b) => (a[1] > b[1] ? a : b))[0];
}
